import { render } from "./NewStarterForm.vue?vue&type=template&id=d05e3558&scoped=true&ts=true"
import script from "./NewStarterForm.vue?vue&type=script&lang=ts"
export * from "./NewStarterForm.vue?vue&type=script&lang=ts"

import "./NewStarterForm.vue?vue&type=style&index=0&id=d05e3558&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d05e3558"]])

export default __exports__